import { Theme } from '@mui/material';

export const textFieldStyles = (theme: Theme) => ({
  MuiTextField: {
    styleOverrides: {
      root: {
        height: '100%',
        color: theme.palette.text.primary,
        '& .MuiInputBase-input': {
          color: theme.palette.text.primary, // Specifically targets input text
        },
        '& .MuiInputBase-root.Mui-disabled': {
          color: '#FFF',
        },
        '&.Mui-focused': {},
        '@media (max-width: 600px)': {
          width: '100%', // Full width on small screens
        },
      },
    },
  },
});
